import { Pagination } from '@material-ui/lab';
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

const styles = (theme => ({
  paginationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      height: 60,
    },
  },
  paginationDetails: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 2, 0, 0),
    },
  },
}));

const CommonPagination = ({
                            totalCount,
                            page,
                            size,
                            onChange,
                            classes,
                            pageCount,
                            itemsFrom,
                            itemsTo,
                            showDetails,
                            siblingCount,
                          }) => {
  
  const renderPaginationDetails = showDetails && itemsFrom && totalCount;
  return (
    <div className={classes.paginationWrapper}>
      {renderPaginationDetails && <Box className={classes.paginationDetails}>
        {itemsFrom} - {itemsTo}&nbsp;
        <FormattedMessage id="pagination.of" defaultMessage="of" />&nbsp;
        <b>{totalCount}</b>&nbsp;
        <FormattedMessage id="pagination.hits" defaultMessage="hits" />
      </Box>}
      <Pagination
        siblingCount={siblingCount}
        page={page}
        size={size}
        onChange={onChange}
        count={pageCount}
      />
    </div>
  );
};

CommonPagination.defaultProps = {
  showDetails: true,
  siblingCount: 1,
};

CommonPagination.propTypes = {
  totalCount: PropTypes.number,
  page: PropTypes.number,
  size: PropTypes.string,
  siblingCount: PropTypes.number,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  pageCount: PropTypes.number,
  itemsFrom: PropTypes.number,
  itemsTo: PropTypes.number,
  showDetails: PropTypes.bool,
};

export default withStyles(styles)(CommonPagination);